export default __webpack_public_path__ + "static/media/help-desk-3.00181826.png";